import {Flex, Input, Space} from "antd";
import {useState} from "react";
import {StorageProvider, StorageProviderSettings} from "../StorageProvider";

export const AmazonStorageSettings = (props: {
    provider: StorageProvider,
    settings: StorageProviderSettings,
    onChange: (settings: StorageProviderSettings) => void
}) => {
    const [accessKey, setAccessKey] = useState(props.settings.settings.accessKey)
    const [secretKey, setSecretKey] = useState(props.settings.settings.secretKey)
    const [region, setRegion] = useState(props.settings.settings.region)
    const [bucket, setBucket] = useState(props.settings.settings.bucket)

    return (
        <Flex gap={10}>
            <Flex vertical={true} gap={18} style={{paddingTop: 5}}>
                <div><b>Access Key:</b></div>
                <div><b>Secret Key:</b></div>
                <div><b>Region:</b></div>
                <div><b>Bucket:</b></div>
            </Flex>
            <Space direction={'vertical'} style={{flexGrow: 1}}>
                <Input placeholder="Access Key" value={accessKey} onChange={e => {
                    setAccessKey(e.target.value)
                    props.onChange({
                        ...props.settings,
                        settings: {...props.settings.settings, accessKey: e.target.value}
                    })
                }}/>
                <Input placeholder="Secret Key" value={secretKey} onChange={e => {
                    setSecretKey(e.target.value)
                    props.onChange({
                        ...props.settings,
                        settings: {...props.settings.settings, secretKey: e.target.value}
                    })
                }}/>
                <Input placeholder="Region" value={region} onChange={e => {
                    setRegion(e.target.value)
                    props.onChange({...props.settings, settings: {...props.settings.settings, region: e.target.value}})
                }}/>
                <Input placeholder="Bucket" value={bucket} onChange={e => {
                    setBucket(e.target.value)
                    props.onChange({...props.settings, settings: {...props.settings.settings, bucket: e.target.value}})
                }}/>
            </Space>
        </Flex>
    )
}